module.exports = __webpack_public_path__ + "static/media/static-malware-classification.dae65168.png";